// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "global." + {"301":"24bcd9f313595ec0efb9","554":"59c646ce1db6c7f96d31"}[chunkId] + ".js";
};